import { render, staticRenderFns } from "./AddActivityDialog.vue?vue&type=template&id=31a56f2f&scoped=true"
import script from "./AddActivityDialog.vue?vue&type=script&lang=js"
export * from "./AddActivityDialog.vue?vue&type=script&lang=js"
import style0 from "./AddActivityDialog.vue?vue&type=style&index=0&id=31a56f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a56f2f",
  null
  
)

export default component.exports